import { useContext } from 'react';
import { Ui, UiContext } from 'context';

const useUi = (): Ui => useContext(UiContext);

export default useUi;
